module.exports = __webpack_public_path__ + "img/logo_full.ccb2549c.png";